const jobs = require('../data/readingJobs');
const { calculateVoiceQuote } = require('./voicePricing');
function prepareVoiceApplication(body = {}) {
  if (!body || typeof body !== 'object') throw Error('応募内容が不正です。');
  const job = jobs.find(j => j.chapter === body.chapter);
  if (!job || typeof body.binaural !== 'boolean' || typeof body.video !== 'boolean' || body.consent !== 'yes') throw Error('募集内容と同意を確認してください。');
  const limits = { name: 120, email: 255, sample: 1000, availability: 200, message: 3000 };
  const data = {};
  for (const [key, max] of Object.entries(limits)) {
    if (typeof body[key] !== 'string' || body[key].trim().length > max || !body[key].trim()) throw Error('入力内容を確認してください。');
    data[key] = body[key].trim();
  }
  const today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Tokyo' }).format(new Date());
  if (!/^\d{4}-\d{2}-\d{2}$/.test(data.availability) || Number.isNaN(Date.parse(data.availability)) || new Date(data.availability).toISOString().slice(0, 10) !== data.availability || data.availability < today) throw Error('納品可能日は本日以降を指定してください。');
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) throw Error('メールアドレスを確認してください。');
  if (data.sample) {
    let url;
    try { url = new URL(data.sample); } catch { throw Error('サンプルURLを確認してください。'); }
    if (!['http:', 'https:'].includes(url.protocol)) throw Error('サンプルURLを確認してください。');
  }
  const quote = calculateVoiceQuote(job.text, { binaural: body.binaural, video: body.video, rate: body.rate });
  const subject = `${job.title}への応募`;
  const text = [subject, `氏名・活動名: ${data.name}`, `メール: ${data.email}`, `サンプル: ${data.sample}`, `納品可能時期: ${data.availability}`, `バイノーラル: ${body.binaural ? 'あり' : 'なし'}`, `朗読動画: ${body.video ? 'あり（顔出し不要・体の撮影必須）' : 'なし'}`, `対象文字数: ${quote.count}`, `希望単価: 1文字${quote.rate}円`, `基本朗読料: ${quote.base}円`, `バイノーラル加算: ${quote.extra}円`, `動画加算: ${quote.videoExtra}円`, `希望報酬総額（税込）: ${quote.gross}円`, `源泉徴収額（国内居住個人の想定）: ${quote.tax}円`, `差引受取額: ${quote.net}円`, '募集内容・個人情報利用への同意: あり', '', data.message].join('\n');
  return { subject, text, quote };
}
module.exports = { prepareVoiceApplication };
